import React from 'react';
import { Box, Collapse, Typography } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

/** Collapsible row for optional listing-modal settings (backfill, sync info). */
const ListingModalExpandRow = ({ label, open, onToggle, children }) => (
  <Box>
    <Box
      component="button"
      type="button"
      onClick={onToggle}
      aria-expanded={open}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        border: 'none',
        bgcolor: 'transparent',
        cursor: 'pointer',
        p: 0,
        py: 0.5,
        textAlign: 'left',
      }}
    >
      <Typography sx={{ fontSize: '0.8125rem', fontWeight: 500, color: 'rgba(0,0,0,0.55)' }}>
        {label}
      </Typography>
      <KeyboardArrowDownIcon
        sx={{
          fontSize: 20,
          color: 'rgba(0,0,0,0.35)',
          transform: open ? 'rotate(180deg)' : 'none',
          transition: 'transform 0.15s ease',
        }}
      />
    </Box>
    <Collapse in={open} unmountOnExit>
      <Box sx={{ pt: 1 }}>{children}</Box>
    </Collapse>
  </Box>
);

export default ListingModalExpandRow;
